import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { SurgicalHistoryModel, SurgTypeModel } from '../models/SurgicalHistoryModel';
import { URLsConfig } from '../URLsConfig';

@Injectable()
export class SurgicalHistoryService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getSurgicalHistory(patientCode: string , compcode: string) {

      let params = new HttpParams();
        params = params.append("PatientCode", patientCode);
        params = params.append("CompCode", compcode);

        const options = {
          params: params
      };
      return this.http.get<SurgicalHistoryModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/SurgicalHistory/GetSurgicalHistory',options);
    }
    public LookupSurgicalHistory() {

      let params = new HttpParams();

        const options = {
          params: params
      };
      return this.http.get<SurgTypeModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/SurgicalHistory/SurTypeLookup',options);
    }

    public AddSurgicalHistory(SHistory: SurgicalHistoryModel) {
      return this.http.post<SurgicalHistoryModel>(this.urlsconfig.WebAPIURL_Test + 'api/SurgicalHistory/AddSurgicalHistory', SHistory);
    }

    public delSurgicalHistory(patientCode: string ,date :string, compcode: string) {

    let params = new HttpParams();
    params = params.append("PatientCode", patientCode);
    params = params.append("Date", date);
    params = params.append("CompCode", compcode);


      const options = {
        params: params
    };
    return this.http.delete<SurgicalHistoryModel>(this.urlsconfig.WebAPIURL_Test + 'api/SurgicalHistory/DeleteSurgicalHistory',options);
    }

  }
